<template>
  <cld-image
      v-if="emblemId"
      :public-id="publicId"
      :width="size"
      dpr="3.0"
      crop="fill"
      class="d-inline-flex align-middle cld-hidpi">
    <cld-transformation v-if="shadow" effect="shadow:0" x="1" y="1"/>
  </cld-image>
</template>

<script>
export default {
  props: {
    emblemId: String,
    size: String,
    shadow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    publicId() {
      return 'sandkastenliga/emblems/' + this.emblemId;
    }
  }
}
</script>
